import React from 'react';
import Property from './Property';
import PropTypes from 'prop-types';
import VisibilitySensor from 'react-visibility-sensor';

export default class Properties extends React.PureComponent {
    static propTypes = {
        properties: PropTypes.object
    };
    state = {
        animFired: false
    };

    items = [];

    onStaggerIn = (isVisible) => {
        const items = this.items || [];
        if (isVisible && !this.state.animFired && items.length > 0) {
            TweenMax.staggerFromTo(
                items,
                1.25,
                {y: 100, autoAlpha: 0},
                {
                    y: 0,
                    autoAlpha: 1,
                    ease: Power3.easeOut,
                    onComplete: this.hasCompleted()
                },
                0.3
            );
        }
    };

    hasCompleted = () => {
        this.setState({animFired: true});
    };

    render() {
        const {properties} = this.props;
        const {subTitle, title, items} = properties;
        if (title === undefined) return <div />;

        return (
            <VisibilitySensor
                onChange={this.onStaggerIn}
                partialVisibility
                scrollCheck={false}
                scrollDelay={10}>
                <section className="careers-property-featured">
                    <div className="careers-section-header">
                        <h1>{title}</h1>
                        <div className="h2">{subTitle}</div>
                    </div>
                    <div className="container">
                        <div className="row">
                            {items !== undefined && items.length > 0 ? (
                                items.map((item, index) => {
                                    const i = index;
                                    return (
                                        <div
                                            key={`item${i}`}
                                            ref={(c) => {
                                                this.items[i] = c;
                                            }}
                                            className="career-property-wrapper col-xs-12 col-xs-offset-0 col-md-4">
                                            <Property
                                                title={item.title}
                                                description={item.description}
                                            />
                                        </div>
                                    );
                                })
                            ) : (
                                <div />
                            )}
                        </div>
                    </div>
                </section>
            </VisibilitySensor>
        );
    }
}
